import * as THREE from "three";
import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from "@material-ui/core";
import SideStyle from '../style/sideStyle';
import Control from '../store/control';
import Param from '../store/param';
import { AddIcon } from './formUtil';
import { toast } from 'react-toastify';

import { STLExporter } from 'three/addons/exporters/STLExporter.js';
import * as helptext from './helptext';

const FormOutput = () => {
  const style         = SideStyle();
  const setParam      = Param.Get('setParam');
  const setup         = Param.Get('setup');
  const output        = Param.Get('output');
  const tsfd          = Control.Get('tsfd');
  const meshOutputAk  = Control.Get('meshOutputAk');
  const setControl    = Control.Get('setControl')

  useEffect(() => {
    setParam(s => {s.output.step = 0});
  }, []);

  const handleValue = (e) => {
    setParam(s => {s.output[e.target.name] = Number(e.target.value)});
  };

  const onThick = () => {
    setParam(s => {s.output.step = 1});
  };

  function save( blob, filename ) {
    const link = document.createElement( 'a' );
    link.style.display = 'none';
    document.body.appendChild( link );
    
    link.href = URL.createObjectURL( blob );
    link.download = filename;
    link.click();
  }

  function saveArrayBuffer( buffer, filename ) {
    save( new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename );
  }

  const handleExport = (outputGeom) => {
    if (outputGeom == null) {
      toast.error('No mesh to export.')
      return;
    }

    // deepCopy
    let saveGeom = outputGeom.clone();
    
    // mirror
    if ( setup.side == 1 ) {
      var mS = (new THREE.Matrix4()).identity();
      mS.elements[0] = -1; // mirror, but flip normal, so we need to flip back
      saveGeom = saveGeom.applyMatrix4(mS);

      // flip normal
      const faceIndices = saveGeom.index;
      for (let i = 0; i < faceIndices.array.length; i += 3) {
        const tmp = faceIndices.array[i];
        faceIndices.array[i] = faceIndices.array[i + 2];
        faceIndices.array[i + 2] = tmp;
      }
      saveGeom.setIndex(faceIndices);
      saveGeom.index.needsUpdate = true;
    }

    // save mesh
    const scene = new THREE.Scene();
    const material = new THREE.MeshStandardMaterial( { color: 0x000000 } );
    saveGeom.rotateX(Math.PI/2);
    let mesh = new THREE.Mesh(saveGeom, material);

    scene.add(mesh.clone());

    const exporter = new STLExporter();
    const result = exporter.parse( scene, { binary: true } );

    saveArrayBuffer( result, 'socket.stl' );

    setParam(s => { s.exportModel += 1 });
  }

  if (tsfd==='ts') {
    return (
      <div className={style.outside}>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='socketThickness'
            label='Socket thickness'
            type='number'
            defaultValue={output.socketThickness}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.socketThickness; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.socketThickness}
              //   title='Socket thickness'
              //   // imgSrc='./static/ak/img/socketThickness.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='splitAdjust'
            label='Split height adjustment'
            type='number'
            defaultValue={output.splitAdjust}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.splitAdjust; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.splitAdjust}
              //   title='Split height adjustment'
              //   // imgSrc='./static/ak/img/splitAdjust.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='radiusCheckHole'
            label='Radius of check hole'
            type='number'
            defaultValue={output.radiusCheckHole}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.radiusCheckHole; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.radiusCheckHole}
              //   title='Radius of check hole'
              //   // imgSrc='./static/ak/img/radiusCheckHole.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='intervalCheckHole'
            label='Interval of check hole'
            type='number'
            defaultValue={output.intervalCheckHole}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.intervalCheckHole; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.intervalCheckHole}
              //   title='Interval of check hole'
              //   // imgSrc='./static/ak/img/intervalCheckHole.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            disabled={true}
            id='filled-number'
            name='engraving'
            label='Engraving number'
            type='number'
            defaultValue={output.engraving}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.engraving; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit=''
              //   helptext={helptext.engraving}
              //   title='Engraving number'
              //   // imgSrc='./static/ak/img/intervalCheckHole.png'
              // />,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-1, 
              max:99999999,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Button className={style.button} onClick={onThick} >Thicken</Button>
        </Grid>

        {/*  Output button */}
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Button
            component='label'
            className={style.button}
            onClick={()=>handleExport(meshOutputAk)}>
            Export STL
          </Button>
        </Grid>
      </div>
    );
  }


  if (tsfd==='fd') {
    return (
      <div className={style.outside}>
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            id='filled-number'
            name='socketThicknessFd'
            label='Socket thickness'
            type='number'
            defaultValue={output.socketThicknessFd}
            fullWidth
            onBlur={handleValue}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.socketThickness; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.socketThickness}
              //   title='Socket thickness'
              //   // imgSrc='./static/ak/img/socketThickness.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />

          <Grid container spacing={1} alignItems='center' justifyContent='center'>
            <TextField
              id='filled-number'
              name='splitAdjust'
              label='Split height adjustment'
              type='number'
              defaultValue={output.splitAdjust}
              fullWidth
              onBlur={handleValue}
              onMouseOver={() => setControl(s => {s.explanationText = helptext.splitAdjust; s.explanationImg = ''})}
              onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
              InputProps={{
                endAdornment: <InputAdornment position="start">mm</InputAdornment>,
                // endAdornment: 
                // <AddIcon 
                //   unit='mm'
                //   helptext={helptext.splitAdjust}
                //   title='Split height adjustment'
                //   // imgSrc='./static/ak/img/splitAdjust.png'
                // />,
              }}
              InputLabelProps={{
                style: { color: '#fff' },
                shrink: true,
              }}
              variant='standard'
              inputProps={{
                style: {
                  color: 'white',
                  textAlign: 'left'
                }, 
                min:-100, 
                max:100,
                step:1
              }}
            />
          </Grid>

          {/*
          <TextField
            id='filled-number'
            name='splitHeight'
            label='Split Height'
            type='number'
            defaultValue={output.splitHeight}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Split height'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-100, 
              max:100,
              step:1
            }}
          />
          */}
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <TextField
            disabled={true}
            id='filled-number'
            name='engraving'
            label='Engraving number'
            type='number'
            defaultValue={output.engraving}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.engraving; s.explanationImg = ''})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit=''
              //   helptext={helptext.engraving}
              //   title='Engraving number'
              //   // imgSrc='./static/ak/img/intervalCheckHole.png'
              // />,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-1, 
              max:99999999,
              step:1
            }}
          />
        </Grid>

        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Button className={style.button} onClick={onThick} >Thicken</Button>
        </Grid>

        {/*  Output button */}
        <Grid container spacing={1} alignItems='center' justifyContent='center'>
          <Button
            component='label'
            className={style.button}
            onClick={()=>handleExport(meshOutputAk)}>
            Export STL
          </Button>
        </Grid>
      </div>
    );
  }
}
export default FormOutput;
